class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
     /*console.log(
      'parsedState:',
      JSON.stringify(parsedState, null, 2)
    );*/

    
    this.cartItemKey = parsedState.key;

    // -------------------------------------------------------------
    // ▼▼▼ START: 新增的优惠信息计算和渲染逻辑 ▼▼▼
    // -------------------------------------------------------------
  
    // 1. 获取购物车商品总数
    const cartButtonHTML = parsedState.sections['cart-notification-button'];
    // 使用正则表达式从 "View cart (2)" 中匹配括号里的数字
    const countMatch = cartButtonHTML.match(/\((\d+)\)/);
    const totalItemsInCart = countMatch ? parseInt(countMatch[1], 10) : 0;
    
    // 如果匹配失败（虽然不太可能），可以再尝试从 cart-icon-bubble 获取作为备用方案
    if (totalItemsInCart === 0) {
        const cartIconBubbleHTML = parsedState.sections['cart-icon-bubble'];
        const bubbleMatch = cartIconBubbleHTML.match(/<span aria-hidden="true">(\d+)<\/span>/);
        if (bubbleMatch) {
            totalItemsInCart = parseInt(bubbleMatch[1], 10);
        }
    }
    // 2. 定义我们的优惠规则和文案
    let upsellMessage = '';
      if (totalItemsInCart === 1) {
        upsellMessage = 'Add 1 more item to get 10% OFF!';
      } else if (totalItemsInCart === 2) {
        upsellMessage = 'Add 1 more item to get 15% OFF!';
      } else if (totalItemsInCart === 3) {
        upsellMessage = 'Add 1 more item to get 20% OFF!';
      }
    //console.log(upsellMessage);
    
    // 3. 准备已享受的折扣信息
    let savingsHTML = '';
    if (parsedState.line_level_discount_allocations && parsedState.line_level_discount_allocations.length > 0) {
        parsedState.line_level_discount_allocations.forEach(discountAllocation => {
            const discount = discountAllocation.discount_application;
            const savedAmount = discountAllocation.amount;
            const formattedAmount = `$${(savedAmount / 100).toFixed(2)}`;
            
            // ▼▼▼ 使用与 CSS 匹配的 class 名称 ▼▼▼
            savingsHTML += `
                <div class="cart-footer__discount-item cart-footer__discount-item--auto">
                    <svg class="icon-discount" ... >...</svg> <!-- 替换成你的折扣图标SVG代码 -->
                    <span>${discount.title}</span>
                    <span class="cart-footer__discount-amount">(-${formattedAmount})</span>
                </div>
            `;
        });
    }
    
    // 4. 将信息渲染到弹窗的容器中
    const discountsContainer = document.getElementById('cart-notification-discounts');
    if (discountsContainer) {
        // ▼▼▼ 使用与 CSS 匹配的 class 名称 ▼▼▼
        discountsContainer.className = 'cart-footer__discounts-wrapper'; // 给容器也加上 class
    
        let contentToRender = '';
    
        if (upsellMessage) {
            contentToRender += `
                <div class="cart-footer__upsell-notice">
                    <svg class="icon-sparkle" ... >...</svg> <!-- 替换成你的闪亮图标SVG代码 -->
                    <span>${upsellMessage}</span>
                </div>
            `;
        }
    
        contentToRender += savingsHTML;
        
        discountsContainer.innerHTML = contentToRender;
    }
    
    // -----------------------------------------------------------
    // ▲▲▲ END: 新增逻辑 ▲▲▲
    // -----------------------------------------------------------

    
    this.getSectionsToRender().forEach((section) => {
      // 1. 取出要渲染的新 HTML
      const html = parsedState.sections[section.id];
      const inner = this.getSectionInnerHTML(html, section.selector);
  
      if (section.id === 'cart-icon-bubble') {
        // 2. 对于 bubble，用 querySelectorAll 批量更新
        document.querySelectorAll('#cart-icon-bubble').forEach((el) => {
          el.innerHTML = inner;
        });
      } else {
        // 3. 其它 section 继续用 getElementById
        const el = document.getElementById(section.id);
        if (el) el.innerHTML = inner;
      }
    });
  
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {    
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);